module.exports = __webpack_public_path__ + "img/compact.402096e1.png";